enum AIFeature {
  TEXT_ENHANCEMENT = "TEXT_ENHANCEMENT"
}

export default AIFeature;
